export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/5ba84b7c5997e2a9223c26a23a6fa17e.svg";